module.exports = __webpack_public_path__ + "img/sDblMnky_193x205.009fa0fb.png";